module.exports = __webpack_public_path__ + "img/preloader350x534.7b9f9821.gif";